import app from 'app';
import wtCropping from './wtCropping.component.vue';
export default function croppingModal({
  main,
  overlay,
  offset,
  selectedAsset = 'main',
  disableMain = false,
  disableOverlay = false,
  currentTime = 0,
  sendNull,
  visibleCurtains = false,
  sceneLayoutSTPModel = null,
}) {
  return app.showModal({
    showCloseButton: false,
    type: 'cropping',
    transitionName: 'none',
    component: wtCropping,
    componentPropsData: {
      main,
      overlay,
      disableMain,
      disableOverlay,
      selectedAsset,
      currentTime,
      sendNull,
      visibleCurtains,
      sceneLayoutSTPModel,
    },
    offset: offset
      ? {
          top: offset.top - 50,
          left: offset.left,
        }
      : null,
  });
}
